import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

import MoveYouOutWrapper from "@components/layouts/moveyououtWrapper";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <MoveYouOutWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#f3ba28" />
                </div>
                <FormSection iconsFillColor="#f3ba28" />
            </div>
        </MoveYouOutWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
